module.exports = __webpack_public_path__ + "static/media/cloud-d3-v3@2x.23ca1965.png";